define('lq/viewTransitionManager',[
], function () {

    function ViewTransitionManager() {
        this.viewTransitions = [];
    }

    ViewTransitionManager.prototype.scheduleViewTransition = function (startCallback) {
        var self = this;
        if (document.startViewTransition) {
            return new Promise(function (resolve) {
                self.viewTransitions.push({start: startCallback, resolve: resolve});
                if (self.viewTransitions.length === 1) {
                    self.startViewTransition(startCallback, resolve);
                }
            });
        } else {
            return Promise.resolve(startCallback());
        }
    };

    ViewTransitionManager.prototype.startViewTransition = function (startCallback, resolve) {
        var self = this;
        requestAnimationFrame(function() {
            var vt = document.startViewTransition(function() {
                return new Promise(function(resolve) {
                    Promise.resolve(startCallback())
                        .then(resolve);
                });
            });
            vt.updateCallbackDone.then(function() {
                resolve();
                // Remove the first element the JS way
                self.viewTransitions.shift();
                if (self.viewTransitions.length > 0) {
                    self.startViewTransition(
                        self.viewTransitions[0].start,
                        self.viewTransitions[0].resolve);
                }
            });
        });
    };

    return ViewTransitionManager;
});
